import { render, staticRenderFns } from "./global_hotWord.vue?vue&type=template&id=26be1550&scoped=true&"
import script from "./global_hotWord.vue?vue&type=script&lang=js&"
export * from "./global_hotWord.vue?vue&type=script&lang=js&"
import style0 from "./global_hotWord.vue?vue&type=style&index=0&id=26be1550&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26be1550",
  null
  
)

export default component.exports